import { AdvertSlotDfp, ADBRIDG_CLASS } from '@zoopla/adverts/dfp';

const breakpoints = {
    lsrpSidebar: 1140,
    desktop: 960
};

type SlotConfig = {
    adbridgClass: string;
    listingZeroIdxPos: number;
};

export const DESKTOP_LSRP_AD_SLOT_POSITIONS: SlotConfig[] = [
    {
        adbridgClass: ADBRIDG_CLASS.INTERSTITIAL_DESKTOP,
        listingZeroIdxPos: 2
    },
    {
        adbridgClass: ADBRIDG_CLASS.INTERSTITIAL_DESKTOP,
        listingZeroIdxPos: 7
    },
    {
        adbridgClass: ADBRIDG_CLASS.INTERSTITIAL_DESKTOP,
        listingZeroIdxPos: 12
    },
    {
        adbridgClass: ADBRIDG_CLASS.INTERSTITIAL_DESKTOP,
        listingZeroIdxPos: 17
    },
    {
        adbridgClass: ADBRIDG_CLASS.INTERSTITIAL_DESKTOP,
        listingZeroIdxPos: 22
    }
];

export const MOBILE_LSRP_AD_SLOT_POSITIONS: SlotConfig[] = [
    {
        adbridgClass: ADBRIDG_CLASS.INTERSTITIAL_MOBILE,
        listingZeroIdxPos: 0
    },
    {
        adbridgClass: ADBRIDG_CLASS.INTERSTITIAL_MOBILE,
        listingZeroIdxPos: 7
    },
    {
        adbridgClass: ADBRIDG_CLASS.INLINE_SPECIAL,
        listingZeroIdxPos: 7
    },
    {
        adbridgClass: ADBRIDG_CLASS.INTERSTITIAL_MOBILE,
        listingZeroIdxPos: 12
    },
    {
        adbridgClass: ADBRIDG_CLASS.INTERSTITIAL_MOBILE,
        listingZeroIdxPos: 17
    },
    {
        adbridgClass: ADBRIDG_CLASS.INTERSTITIAL_MOBILE,
        listingZeroIdxPos: 22
    }
];

type IntegratedListingAdSlotProps = {
    listingIndex: number;
    useMobileConfig?: boolean;
};

export const IntegratedListingAdSlot = ({
    useMobileConfig,
    listingIndex
}: IntegratedListingAdSlotProps) => {
    const adArray = useMobileConfig
        ? MOBILE_LSRP_AD_SLOT_POSITIONS
        : DESKTOP_LSRP_AD_SLOT_POSITIONS;

    const adSlots = adArray.filter(({ listingZeroIdxPos }) => {
        return listingZeroIdxPos === listingIndex;
    });

    return (
        <>
            {adSlots.map(({ adbridgClass }) => {
                return (
                    <AdvertSlotDfp
                        key={'ad' + adbridgClass ?? '' + listingIndex}
                        showOnly={[
                            useMobileConfig ? '<' : '>',
                            breakpoints.lsrpSidebar
                        ]}
                        adbridgClass={adbridgClass}
                    />
                );
            })}
        </>
    );
};
